import React, { useState, useEffect } from "react";
import styled from "styled-components/macro";
import MailPlus from "lib/images/mail-plus.svg";
import { CampaignCategory } from "pages/dealScreener/Email/constants";
import { PrimaryButton, SecondaryButton, ButtonSizeOptions } from "@loanbossinc/component-library";

import { LabelOptionTypes } from "../constants";
import { LabelOption } from "..";

const StyledBodyContainer = styled.div`
  width: 490px;
  height: 464px;
  background-color: #FFFFFF;
  border-radius: 12px;
  box-shadow: 0px 4px 8px 0px #00000040;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  font-family: Metropolis;
  gap: 2em;
  padding: 2em 1em;
`;

const ImgTitleWrapper = styled.div`
  display: inherit;
  flex-direction: inherit;
  gap: 1.3em;
`;

const StyledImg = styled.img`
  height: 48px;
`;

const Title = styled.div`
  font-size: 20px;
  font-weight: 100;
  line-height: 24px;
  color: #102F54CC;
`;

const BodyWrapper = styled.div`
  align-items: flex-start;
  width: 80%;
  display: inherit;
  flex-direction: column;
  gap: 1em;
`;

const ButtonFooter = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1em;
`;

const RadioOptions = [
  {
    name: CampaignCategory.DEAL.name,
    id: CampaignCategory.DEAL.id
  }
  /*
   * Excluding Portfolio for now based on convo with Heather. We don't have a Your Debt With Us static page done yet, so removing this for now.
   * #2xj7ex2 20220701 Tim Lee
   * {
   *   name: CampaignCategory.PORTFOLIO.name,
   *   id: CampaignCategory.PORTFOLIO.id
   * }
   */
];

const NewBlastModalBody = ({
  selectedBlastLevel,
  setSelectedBlastLevel,
  selectedBlastType,
  setSelectedBlastType,
  blastTypeOptions,
  blastName,
  setBlastName,
  onCancelClicked: handleOnCancel,
  onCreateClicked: handleOnCreate,
  isBlastTypeValid,
  isBlastNameValid
}) => {
  const [showNameRequired, setShowNameRequired] = useState(false);
  const [showTypeRequired, setShowTypeRequired] = useState(false);

  useEffect(() => {
    if (blastName) {
      setShowNameRequired(false);
    }
    if (selectedBlastType) {
      setShowTypeRequired(false);
    }
  }, [blastName, selectedBlastType]);

  const handleBlastLevelChange = event => setSelectedBlastLevel(event.target.value);
  const handleBlastTypeChange = event => setSelectedBlastType(event.target.value);
  const handleBlastNameChange = event => setBlastName(event.target.value);

  const handleValidityCheck = () => {
    if (isBlastNameValid && isBlastTypeValid) {
      handleOnCreate();
    }
    if (!isBlastNameValid) {
      setShowNameRequired(true);
    }
    if (!isBlastTypeValid) {
      setShowTypeRequired(true);
    }
  };

  return (
    <StyledBodyContainer>
      <ImgTitleWrapper>
        <StyledImg src={MailPlus} alt="mail-plus" />
        <Title>Create New Email</Title>
      </ImgTitleWrapper>
      <BodyWrapper>
        <LabelOption
          label="EMAIL LEVEL"
          type={LabelOptionTypes.RADIO}
          options={RadioOptions}
          value={selectedBlastLevel}
          onChange={handleBlastLevelChange}
        />
        <LabelOption
          label="EMAIL TYPE"
          type={LabelOptionTypes.DROPDOWN}
          options={blastTypeOptions}
          value={selectedBlastType}
          onChange={handleBlastTypeChange}
          showTypeRequired={showTypeRequired}
        />
        <LabelOption
          label="EMAIL NAME"
          type={LabelOptionTypes.INPUT}
          value={blastName}
          onChange={handleBlastNameChange}
          showNameRequired={showNameRequired}
        />
      </BodyWrapper>
      <ButtonFooter>
        <SecondaryButton
          label="Cancel"
          size={ButtonSizeOptions.smFluid}
          style={{ width: 132 }}
          onClick={handleOnCancel}
        />
        <PrimaryButton
          label={`${selectedBlastLevel === CampaignCategory.DEAL.id ? "Continue to deal screener" : "Create"}`}
          size={ButtonSizeOptions.smFluid}
          onClick={handleValidityCheck}
          style={{ width: "fit-content" }}
        />
      </ButtonFooter>
    </StyledBodyContainer>
  );
};

export default NewBlastModalBody;
